export const INDEX_TYPES = {
  DYNAMIC: "DYNAMIC",
  SET: "SET",
};
